import type { IconNode } from '../types';

/**
 * @name square-letter-e
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgOEg5LjVhLjUuNSAwIDAgMC0uNS41djdhLjUuNSAwIDAgMCAuNS41SDE1IiAvPgogIDxwYXRoIGQ9Ik05IDEyaDQiIC8+CiAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiB4PSIzIiB5PSIzIiByeD0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/square-letter-e
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SquareLetterE: IconNode = [
  ['path', { d: 'M15 8H9.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H15' }],
  ['path', { d: 'M9 12h4' }],
  ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2' }],
];

export default SquareLetterE;
